import { type Date as ProtoDate } from '@ebalance/proto/google/type/date_pb'

import { fromProtoDate } from '~/models/dateTime'

/**
 * 計画の作成完了時に一覧の対象日フィルタを切り替える先 (AC-PLC-054)。 切り替えない時は
 * undefined。 一覧の「計画作成」 の完了時と、 詳細の「計画を作り直す」 (AC-PLC-020-2) で
 * 作成して一覧へ来た時 (location state の作成日) に、 一覧がこの判定で対象日を決める。
 *
 * 各一覧は対象日 1 日ぶんしか表示しないため、 切り替えないと一覧の現在の対象日と
 * 異なる日で作成した計画が画面に現れず、 ユーザーが作成失敗と誤認して再作成し版が
 * 積み上がる (#6579 決定 A)。 対象日以外のフィルタ (エリア / 種別 / 最新のみ) は触らない。
 *
 * ケース対象日で固定中 (`isDateLocked`) は切り替えない。 一覧の表示日はケース対象日が
 * 優先する (AC-WFW-006a、 `docs/specs/workflow/workflow.md`) ため追随できず、
 * localStorage の永続値だけを汚してしまう。 `isDateLocked` はケース取得前・targetDate
 * 欠落でも true になる fail-closed 側の判定。
 */
export function listTargetDateAfterCreate(
  targetPeriodStartDate: ProtoDate,
  isDateLocked: boolean,
): Date | undefined {
  return isDateLocked ? undefined : fromProtoDate(targetPeriodStartDate)
}
